import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index"; // import studentScore from "./studentScore.vue";

import lineupBoard from "./lineupBoard.vue";
export default {
  mixins: [loadMoreList, commonData],
  components: {
    lineupBoard: lineupBoard
  },
  props: ['teamId'],
  data: function data() {
    return {
      dialogFormVisible: false,
      tournamentId: '',
      tableData: [],
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.tournamentId = data;

                  _this.getScoreListFn();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getScoreListFn: function getScoreListFn() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.paramsData.page = page;
      this.$api.matchList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        team_id: this.teamId,
        tournament_id: this.tournamentId
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data.data;
          data.forEach(function (item) {
            item.location = item.venue ? item.venue.location : '/';
            item.winnerName = item.winner ? item.winner.name : '/';
          });
          _this2.tableData = data;
          _this2.total = res.data.total;
        }
      });
    }
  }
};